import { createFileRoute } from '@tanstack/react-router';
import { LedgerNewTransferPage } from './LedgerNewTransferPage';
import z from 'zod';

const searchSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/ledger/new-transfer/')({
  component: LedgerNewTransferPage,
  validateSearch: searchSchema,
});
